<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <span class="text-sm text-gray-500" :class="{ 'blur': !isPriceVisible }">
        {{ price }}
    </span>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'ReturnOrderPriceCell',

    props:
    {
        row:
        {
            type:     Object,
            required: true,
        },

        rows:
        {
            type:     Array,
            required: true,
        },

        column:
        {
            type:     Object,
            required: true,
        },

        updating:
        {
            type:    Boolean,
            default: false,
        },
    },

    computed:
    {
        price()
        {
            if(this.$store.getters['account/can']('price:view'))
            {
                const price = (this.row.order.special_price !== null) ? this.row.order.special_price : this.row.order.total;

                return this.$f(price, "numberFormat:2,'");
            }
            else
            {
                return '-';
            }
        },

        isPriceVisible()
        {
            return this.$store.state.pricesVisible;
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>


</style>
